import styled from "styled-components";

// Usage
// <StyledInput type="text" />
const StyledInput = styled.input`
  display: block;
  margin: 0 auto;
  padding: 0.625rem;
  margin-top: 0.625rem;
  margin-bottom: 1.25rem;
  width: 100%;
  background: #FFFFFF;
  border: 0.063rem solid #d9d9d9;
  box-shadow: 0rem 0.063rem 0.125rem rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
  box-sizing: border-box;
  font-size: 100%;

  &:hover {
    border-color: #baa1de;
  }

  &:focus {
    outline: none;
    border-color: #f5edff;
    box-shadow: 0 0 0 0.125rem #f5edff;
  }
`;
export default StyledInput;